import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';

  :global(.IBPageLayout) {
    margin-top: 0 !important;
  }

  :global(.IBPageLayout .PageLayout__header) {
    display: none !important;
  }

  .IBForm {
    max-width: 960px;
    margin: 0 auto;
    padding: 40px 48px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    @include respond-to(sm) {
      padding: 24px 20px;
    }
  }

  .IBForm__title {
    font-size: 24px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 8px 0;
  }

  .IBForm__subtitle {
    font-size: 15px;
    color: #6b7280;
    margin: 0 0 24px 0;
    line-height: 1.5;
  }

  .IBForm__divider {
    height: 1px;
    background: #e5e7eb;
    margin: 28px 0;
  }

  .IBForm__section {
    margin-bottom: 32px;
  }

  .IBForm__label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 10px;
  }

  .IBForm__select-wrapper {
    position: relative;
    width: 300px;
    @include respond-to(sm) {
      width: 100%;
    }
  }

  .IBForm__select {
    width: 100%;
    padding: 10px 36px 10px 14px;
    font-size: 14px;
    color: #1f2937;
    background: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%236B7280' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 14px center;
    transition: border-color 0.2s;
  }

  .IBForm__select:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
  }

  .IBForm__question {
    font-size: 15px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 16px 0;
    line-height: 1.5;
  }

  .IBForm__hint {
    font-weight: 400;
    color: #9ca3af;
    font-size: 13px;
  }

  .IBForm__radio-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .IBForm__radio-label {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    font-size: 14px;
    color: #374151;
    user-select: none;
  }

  .IBForm__radio-input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  .IBForm__radio-custom {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    min-width: 20px;
    border: 2px solid #d1d5db;
    border-radius: 50%;
    background: #ffffff;
    transition: all 0.2s;
  }

  .IBForm__radio-input:checked + .IBForm__radio-custom {
    border-color: #6366f1;
  }

  .IBForm__radio-input:checked + .IBForm__radio-custom::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #6366f1;
  }

  .IBForm__checkbox-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    @include respond-to(sm) {
      grid-template-columns: 1fr;
    }
  }

  .IBForm__checkbox-label {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    font-size: 14px;
    color: #374151;
    user-select: none;
  }

  .IBForm__checkbox-input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }

  .IBForm__checkbox-custom {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    min-width: 20px;
    border: 2px solid #d1d5db;
    border-radius: 4px;
    background: #ffffff;
    transition: all 0.2s;
  }

  .IBForm__checkbox-input:checked + .IBForm__checkbox-custom {
    background: #6366f1;
    border-color: #6366f1;
  }

  .IBForm__checkbox-input:checked + .IBForm__checkbox-custom::after {
    content: '';
    position: absolute;
    top: 3px;
    left: 6px;
    width: 5px;
    height: 9px;
    border: solid #ffffff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  .IBForm__text-input {
    width: 100%;
    padding: 12px 16px;
    font-size: 14px;
    color: #1f2937;
    background: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    transition: border-color 0.2s;
    box-sizing: border-box;
  }

  .IBForm__text-input::placeholder {
    color: #9ca3af;
  }

  .IBForm__text-input:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
  }

  .IBForm__sub-section {
    margin-top: 16px;
    margin-left: 0;
    padding-left: 24px;
    border-left: 3px solid #6366f1;
  }

  .IBForm__sub-question {
    font-size: 14px;
    font-weight: 600;
    color: #374151;
    margin: 0 0 12px 0;
    line-height: 1.5;
  }

  .IBForm__error {
    color: #ef4444;
    font-size: 13px;
    margin: 8px 0 0 0;
    font-weight: 500;
  }

  .IBForm__dropzone {
    border: 2px dashed #d1d5db;
    border-radius: 12px;
    background: #f9fafb;
    padding: 32px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;
  }

  .IBForm__dropzone:hover {
    border-color: #6366f1;
    background: #f5f3ff;
  }

  .IBForm__dropzone-text {
    font-size: 14px;
    color: #6b7280;
    margin: 0;
  }

  .IBForm__dropzone-link {
    color: #6366f1;
    font-weight: 500;
    cursor: pointer;
  }

  .IBForm__attachment-list {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .IBForm__attachment-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 14px;
    background: #f3f4f6;
    border-radius: 6px;
  }

  .IBForm__attachment-name {
    font-size: 13px;
    color: #374151;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 280px;
  }

  .IBForm__attachment-remove {
    background: none;
    border: none;
    color: #9ca3af;
    font-size: 20px;
    cursor: pointer;
    padding: 0 4px;
    line-height: 1;
    transition: color 0.2s;
  }

  .IBForm__attachment-remove:hover {
    color: #ef4444;
  }

  .IBForm__submit-wrapper {
    display: flex;
    justify-content: flex-start;
  }

  .IBForm__submit-wrapper--contract {
    justify-content: flex-end;
  }

  .IBForm__submit-btn {
    padding: 12px 32px;
    font-size: 15px;
    font-weight: 600;
    color: #ffffff;
    background: #6366f1;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
    letter-spacing: 0.3px;
  }

  .IBForm__submit-btn:hover {
    background: #4f46e5;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
  }

  .IBForm__submit-btn:active {
    transform: translateY(0);
    box-shadow: none;
  }
`;

export { staticStyles };
